// extracted by mini-css-extract-plugin
module.exports = {"loaderWrapper":"AuthLoader_loaderWrapper__3qqYf","loader":"AuthLoader_loader__1ktKj","rotate":"AuthLoader_rotate__Zf1AS","prixClipFix":"AuthLoader_prixClipFix__2r-We"};